/**
 * Store admin — new quote (Commerce, M4).
 * @see prototype/store/admin/all.html#quotes-new
 */
import { createFileRoute } from "@tanstack/react-router";
import { QuoteNewPage } from "../../../../../features/store/quotes/quote-new-page.tsx";

export const Route = createFileRoute("/(workspace)/store/admin/quotes/new")({
  component: QuoteNewPage,
});
